import { create } from "zustand";
import { persist } from "zustand/middleware";

interface NavState {
  /** Last visited path per workspace key — lets Phase 2 restore the user to
   *  the section they were viewing when they switch back to a workspace. */
  lastPathPerWorkspace: Record<string, string>;
  setLastPath: (workspaceKey: string, path: string) => void;

  /** Whether the desktop sidebar is collapsed to the 64px icon rail. */
  sidebarCollapsed: boolean;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useNavStore = create<NavState>()(
  persist(
    (set) => ({
      lastPathPerWorkspace: {},
      setLastPath: (workspaceKey, path) =>
        set((s) => ({
          lastPathPerWorkspace: { ...s.lastPathPerWorkspace, [workspaceKey]: path },
        })),

      sidebarCollapsed: false,
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
    }),
    { name: "gymviz.nav" },
  ),
);
